import Eye from '../../assets/wod-logo-eye.png'
import Text from '../../assets/wod-logo-text.png'
import Full from '../../assets/wod-logo-full.png'

type LogoProps = {
  showEye?: boolean
  showText?: boolean
  width?: number
  height?: number
}

export const Logo = ({ showEye = true, showText = true, width, height }: LogoProps) => {
  return (
    <div>
      {showEye && showText && buildFullLogo()}
      {showEye && !showText && buildEye(width, height)}
      {showText && !showEye && buildText(width, height)}
    </div>
  )
}

const buildEye = (width?: number, height?: number) => {
  return <img src={Eye} width={width} height={height} />
}

const buildText = (width?: number, height?: number) => {
  return <img src={Text} width={width} height={height} />
}

const buildFullLogo = () => {
  return <img src={Full} width={200} height={287} />
}
